import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { EnlistForm } from "@/components/join/EnlistForm";
import { StatsForm } from "@/components/join/StatsForm";

const TABS = ["enlist", "stats"];

export default function JoinPage() {
  const [tab, setTab] = useState(() => {
    const t = new URLSearchParams(window.location.search).get("tab");
    return TABS.includes(t) ? t : "enlist";
  });
  const [roster, setRoster] = useState({ players: [], recruitingOpen: true });

  useEffect(() => {
    document.title = "We Are Legion · Enlist";
    api.get("/public/roster").then((r) => setRoster(r.data)).catch(() => {});
  }, []);

  return (
    <div className="lg lg-page">
      <div className="lg-wrap lg-fade">
        <div className="lg-eyebrow">We Are Legion · Atlantis</div>
        <h1 className="lg-title">Report for duty</h1>
        <p className="lg-lead">New to the alliance? Send your application and the leaders will see it in Recruit Watch. Already a member? Send your latest stats so the roster stays current. Got a gear setup that works? Use Submit your gear in the member site's Gear Guide tab. No account needed.</p>
        <div className="lg-tabs" role="tablist">
          <button className={`lg-tab ${tab === "enlist" ? "on" : ""}`} onClick={() => setTab("enlist")} data-testid="join-tab-enlist">I want to join</button>
          <button className={`lg-tab ${tab === "stats" ? "on" : ""}`} onClick={() => setTab("stats")} data-testid="join-tab-stats">I'm a member: update stats</button>
        </div>
        <div className="lg-card">
          {tab === "enlist" && <EnlistForm open={roster.recruitingOpen} />}
          {tab === "stats" && <StatsForm players={roster.players} />}
        </div>
        <div className="lg-foot"><Link to="/" data-testid="join-member-preview-link">← Back to member preview</Link></div>
      </div>
    </div>
  );
}
